import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Nosotros',
      services: 'Servicios',
      talent: 'Talento',
      why: 'Por Qué MERAKI',
      partners: 'Alianzas',
      process: 'Proceso',
      contact: 'Contacto',
      apply: 'Aplica Ahora'
    },
    hero: {
      tagline: 'TALENTO GLOBAL. REPRESENTACIÓN ESTRATÉGICA.',
      subtitle: 'Somos la agencia de representación premium que transforma carreras. Artistas, deportistas e influencers alcanzan su máximo potencial con nosotros.',
      cta1: 'Aplica para Representación',
      cta2: 'Contáctanos'
    },
    about: {
      overline: 'Quiénes Somos',
      title: 'MERAKI',
      subtitle: 'Pasión en Todo lo que Hacemos',
      description: 'MERAKI representa la esencia de poner el alma en cada proyecto. Somos una agencia de representación de talento con enfoque internacional, dedicada a impulsar carreras de artistas, deportistas e influencers hacia el éxito global.',
      philosophy: 'Nuestra filosofía combina pasión, estrategia y exclusividad para crear trayectorias únicas.',
      values: {
        title: 'Nuestros Valores',
        professionalism: 'Profesionalismo',
        professionalismDesc: 'Excelencia en cada negociación y representación',
        confidentiality: 'Confidencialidad',
        confidentialityDesc: 'Tu información y contratos, siempre protegidos',
        growth: 'Crecimiento',
        growthDesc: 'Estrategias a largo plazo para tu carrera'
      }
    },
    services: {
      overline: 'Servicios',
      title: 'SOLUCIONES INTEGRALES',
      subtitle: 'Para Cada Tipo de Talento',
      artists: {
        title: 'Artistas',
        items: ['Representación exclusiva', 'Manejo de carrera', 'PR y medios', 'Negociación de contratos', 'Desarrollo de marca personal']
      },
      athletes: {
        title: 'Deportistas',
        items: ['Negociación de contratos', 'Patrocinios deportivos', 'Imagen pública', 'Gestión de transferencias', 'Asesoría post-carrera']
      },
      influencers: {
        title: 'Influencers',
        items: ['Branding personal', 'Colaboraciones con marcas', 'Monetización de contenido', 'Estrategia digital', 'Expansión de audiencia']
      },
      financial: {
        title: 'Operaciones Financieras',
        subtitle: 'Gestión Completa de tus Finanzas',
        items: ['Cobranza y facturación', 'Gestión de pagos', 'Asesoría fiscal e impuestos', 'Planificación financiera', 'Administración de contratos']
      }
    },
    talent: {
      overline: 'Roster',
      title: 'NUESTRO TALENTO',
      subtitle: 'Representamos a los Mejores',
      categories: {
        all: 'Todos',
        artist: 'Artistas',
        athlete: 'Deportistas',
        influencer: 'Influencers'
      }
    },
    why: {
      overline: 'Propuesta de Valor',
      title: 'POR QUÉ MERAKI',
      items: [
        { title: 'Representación Exclusiva', desc: 'Atención personalizada y dedicada a cada talento' },
        { title: 'Red Internacional', desc: 'Conexiones globales con marcas y oportunidades' },
        { title: 'Estrategias Personalizadas', desc: 'Planes únicos diseñados para tus objetivos' },
        { title: 'Enfoque Global', desc: 'Visión internacional para tu crecimiento' }
      ]
    },
    partners: {
      overline: 'Colaboraciones',
      title: 'ALIANZAS ESTRATÉGICAS',
      subtitle: 'Trabajamos con las Mejores Marcas',
      categories: ['Marcas Premium', 'Productoras', 'Agencias', 'Medios'],
      inDevelopment: 'Alianzas en desarrollo'
    },
    process: {
      overline: 'Cómo Trabajamos',
      title: 'PROCESO DE REPRESENTACIÓN',
      steps: [
        { number: '01', title: 'Aplicación', desc: 'Envía tu perfil y portafolio para evaluación' },
        { number: '02', title: 'Evaluación', desc: 'Analizamos tu potencial y fit con nuestra agencia' },
        { number: '03', title: 'Estrategia', desc: 'Diseñamos un plan personalizado para tu carrera' },
        { number: '04', title: 'Representación', desc: 'Comenzamos a trabajar juntos hacia el éxito' }
      ]
    },
    contact: {
      overline: 'Contacto',
      title: 'HABLEMOS',
      subtitle: 'Estamos listos para impulsar tu carrera',
      form: {
        name: 'Nombre completo',
        email: 'Correo electrónico',
        phone: 'Teléfono (opcional)',
        subject: 'Asunto',
        message: 'Tu mensaje',
        submit: 'Enviar Mensaje',
        success: 'Mensaje enviado exitosamente',
        error: 'Error al enviar. Intenta de nuevo.'
      },
      info: {
        location: 'Monterrey, México',
        global: 'Enfoque Global',
        email: 'contacto@meraki.agency'
      },
      apply: {
        title: 'Aplica para Representación',
        fullName: 'Nombre completo',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        category: 'Categoría',
        selectCategory: 'Selecciona una categoría',
        socialMedia: 'Redes sociales principales',
        portfolio: 'URL de portafolio',
        achievements: 'Logros y trayectoria',
        message: 'Mensaje adicional (opcional)',
        submit: 'Enviar Aplicación',
        success: 'Aplicación enviada exitosamente',
        error: 'Error al enviar. Intenta de nuevo.'
      }
    },
    footer: {
      tagline: 'Global Talent. Strategic Representation.',
      rights: 'Todos los derechos reservados',
      privacy: 'Aviso de Privacidad',
      terms: 'Términos y Condiciones',
      social: 'Síguenos'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      talent: 'Talent',
      why: 'Why MERAKI',
      partners: 'Partners',
      process: 'Process',
      contact: 'Contact',
      apply: 'Apply Now'
    },
    hero: {
      tagline: 'GLOBAL TALENT. STRATEGIC REPRESENTATION.',
      subtitle: 'We are the premium representation agency that transforms careers. Artists, athletes, and influencers reach their full potential with us.',
      cta1: 'Apply for Representation',
      cta2: 'Contact Us'
    },
    about: {
      overline: 'About Us',
      title: 'MERAKI',
      subtitle: 'Passion in Everything We Do',
      description: 'MERAKI represents the essence of putting your soul into every project. We are a talent representation agency with an international focus, dedicated to driving the careers of artists, athletes, and influencers towards global success.',
      philosophy: 'Our philosophy combines passion, strategy, and exclusivity to create unique trajectories.',
      values: {
        title: 'Our Values',
        professionalism: 'Professionalism',
        professionalismDesc: 'Excellence in every negotiation and representation',
        confidentiality: 'Confidentiality',
        confidentialityDesc: 'Your information and contracts, always protected',
        growth: 'Growth',
        growthDesc: 'Long-term strategies for your career'
      }
    },
    services: {
      overline: 'Services',
      title: 'COMPREHENSIVE SOLUTIONS',
      subtitle: 'For Every Type of Talent',
      artists: {
        title: 'Artists',
        items: ['Exclusive representation', 'Career management', 'PR and media', 'Contract negotiation', 'Personal brand development']
      },
      athletes: {
        title: 'Athletes',
        items: ['Contract negotiation', 'Sports sponsorships', 'Public image', 'Transfer management', 'Post-career advisory']
      },
      influencers: {
        title: 'Influencers',
        items: ['Personal branding', 'Brand collaborations', 'Content monetization', 'Digital strategy', 'Audience expansion']
      },
      financial: {
        title: 'Financial Operations',
        subtitle: 'Complete Management of Your Finances',
        items: ['Billing and invoicing', 'Payment management', 'Tax advisory', 'Financial planning', 'Contract administration']
      }
    },
    talent: {
      overline: 'Roster',
      title: 'OUR TALENT',
      subtitle: 'We Represent the Best',
      categories: {
        all: 'All',
        artist: 'Artists',
        athlete: 'Athletes',
        influencer: 'Influencers'
      }
    },
    why: {
      overline: 'Value Proposition',
      title: 'WHY MERAKI',
      items: [
        { title: 'Exclusive Representation', desc: 'Personalized and dedicated attention to each talent' },
        { title: 'International Network', desc: 'Global connections with brands and opportunities' },
        { title: 'Personalized Strategies', desc: 'Unique plans designed for your goals' },
        { title: 'Global Focus', desc: 'International vision for your growth' }
      ]
    },
    partners: {
      overline: 'Collaborations',
      title: 'STRATEGIC PARTNERSHIPS',
      subtitle: 'We Work with the Best Brands',
      categories: ['Premium Brands', 'Production Companies', 'Agencies', 'Media'],
      inDevelopment: 'Partnerships in development'
    },
    process: {
      overline: 'How We Work',
      title: 'REPRESENTATION PROCESS',
      steps: [
        { number: '01', title: 'Application', desc: 'Submit your profile and portfolio for evaluation' },
        { number: '02', title: 'Evaluation', desc: 'We analyze your potential and fit with our agency' },
        { number: '03', title: 'Strategy', desc: 'We design a personalized plan for your career' },
        { number: '04', title: 'Representation', desc: 'We start working together towards success' }
      ]
    },
    contact: {
      overline: 'Contact',
      title: "LET'S TALK",
      subtitle: 'We are ready to boost your career',
      form: {
        name: 'Full name',
        email: 'Email address',
        phone: 'Phone (optional)',
        subject: 'Subject',
        message: 'Your message',
        submit: 'Send Message',
        success: 'Message sent successfully',
        error: 'Error sending. Please try again.'
      },
      info: {
        location: 'Monterrey, Mexico',
        global: 'Global Focus',
        email: 'contact@meraki.agency'
      },
      apply: {
        title: 'Apply for Representation',
        fullName: 'Full name',
        email: 'Email address',
        phone: 'Phone',
        category: 'Category',
        selectCategory: 'Select a category',
        socialMedia: 'Main social media',
        portfolio: 'Portfolio URL',
        achievements: 'Achievements and trajectory',
        message: 'Additional message (optional)',
        submit: 'Submit Application',
        success: 'Application submitted successfully',
        error: 'Error submitting. Please try again.'
      }
    },
    footer: {
      tagline: 'Global Talent. Strategic Representation.',
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      social: 'Follow Us'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
